import type PopupBuilder from '@services/payment/PopupBuilder';
import CloudPaymentsPopup from '@services/payment/CloudPaymentsPopup';
import PaySelectionPopup from '@services/payment/PaySelectionPopup';
import {PaymentGates} from '@constants/paymentInfo';
import type {ProductType} from '@constants/productType';

export function getBuilder(
    paymentGate: PaymentGates,
    product: ProductType,
    email: string,
    description: string,
): PopupBuilder {
    switch (paymentGate) {
        case PaymentGates.CloudPayments:
            return new CloudPaymentsPopup(email, description, product);
        case PaymentGates.PaySelection:
            return new PaySelectionPopup(email, description);
        default:
            throw new Error(`Unknown payment gate: ${paymentGate}`);
    }
}
